document.addEventListener('DOMContentLoaded', function() {
  const swiperEl = document.querySelector('.brands__items');
  const autoplayDelay = parseInt(swiperEl?.dataset.autoplayDelay) || 3000;
  const brandsSwiper = new Swiper('.brands__items', {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    centeredSlidesBounds: true,
    autoplay: {
      delay: autoplayDelay,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 6,
      },
      1024: {
        slidesPerView: 7,
      },
      1280: {
        slidesPerView: 8,
      }
    }
  });
}); 